import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import chunk from 'lodash/chunk';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import Link from 'shared/components/Link';
import { getVideoById } from 'shared/actions/journal';
import withPixelRatio from 'shared/hocs/withPixelRatio';
import NewsItem from 'shared/components/NewsItem/NewsItem';
import { buildJournalItemUrl } from 'shared/helpers/urlBuilder';

import s from './NewsBlock.css';

const DEFAULT_CONTAINER_WIDTH = 820;
const HEIGHT_RATIO = 0.5;
const MAX_MOBILE_WIDTH = 560;

class NewsBlock extends React.Component {
  static propTypes = {
    news: PropTypes.arrayOf(PropTypes.shape()).isRequired,
    title: PropTypes.string,
    maxMobileWidth: PropTypes.number,
    columns: PropTypes.number,
    getSelVideo: PropTypes.func.isRequired,
    setRatioImage: PropTypes.func.isRequired,
    isHomeVideo: PropTypes.bool,
    linkToShowAllList: PropTypes.string,
    showAllTitle: PropTypes.string,
    lensEvent: PropTypes.string,
  };
  static defaultProps = {
    title: null,
    lensEvent: '',
    linkToShowAllList: '',
    showAllTitle: '',
    isHomeVideo: false,
    maxMobileWidth: MAX_MOBILE_WIDTH,
    columns: 3,
  };

  state = {
    containerWidth: DEFAULT_CONTAINER_WIDTH,
    maxMobileWidth: this.props.maxMobileWidth,
  };

  componentDidMount() {
    const containerWidth = this.root && this.root.parentNode && this.root.parentNode.offsetWidth;

    if (containerWidth) {
      this.setContainerWidth(containerWidth);
    }
  }

  setContainerWidth = containerWidth => {
    this.setState({ containerWidth });
  };

  render() {
    const {
      title,
      news,
      columns: defaultColumns,
      getSelVideo,
      setRatioImage,
      isHomeVideo,
      linkToShowAllList,
      showAllTitle,
      lensEvent,
    } = this.props;
    const { containerWidth, maxMobileWidth } = this.state;

    const columns = containerWidth < maxMobileWidth ? 1 : defaultColumns;

    const newsImageHeight = (containerWidth / columns) * HEIGHT_RATIO;
    const rows = chunk(news, columns);

    return (
      <div
        className={s.root}
        ref={el => {
          this.root = el;
        }}
      >
        {title &&
          (linkToShowAllList ? (
            <Link to={linkToShowAllList}>
              <span className={s.title}>{title}</span>
            </Link>
          ) : (
            <span className={s.title}>{title}</span>
          ))}

        <div className={s.newsContainer}>
          {rows.map(newsItems => (
            <div key={newsItems[0].id} className={s.row}>
              {newsItems.map(({ id, slug, image, ...props }) => (
                <NewsItem
                  imgHeight={newsImageHeight}
                  className={cx(s.newsItem, { [s.newsItem2Col]: defaultColumns === 2 })}
                  key={id}
                  lensEvent={lensEvent}
                  link={isHomeVideo ? '/zhurnal/video' : buildJournalItemUrl(slug)}
                  image={
                    image && {
                      ...image,
                      url: image.url, // setRatioImage(image.url, containerWidth / columns, newsImageHeight),
                    }
                  }
                  getSelVideo={isHomeVideo ? () => getSelVideo({ id: slug, index: 0 }) : () => {}}
                  {...props}
                />
              ))}
            </div>
          ))}
        </div>
        {showAllTitle &&
         linkToShowAllList &&
          <Link to={linkToShowAllList} >
            <span className={s.showAllTitle}>{showAllTitle} &#8594;</span>
          </Link>
        }
      </div>
    );
  }
}

const mapDispatchToProps = {
  getSelVideo: getVideoById,
};

export default withStyles(s)(
  connect(
    null,
    mapDispatchToProps,
  )(withPixelRatio(NewsBlock)),
);



// WEBPACK FOOTER //
// ./src/desktop/components/NewsBlock/NewsBlock.js